import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import RefundableCheck from '../../RefundableCheck/refundableCheck';

interface Props {
  showModalOrderRef: boolean,
  setShowModalOrderRef: any,
  t: any,
  orderId: number,
}


const RefundOrderModal = (props: Props) => {
  return (
    <Modal show={props.showModalOrderRef} onHide={() => props.setShowModalOrderRef(false)}
    backdrop='static' keyboard={false} size='xl' centered={true}>
        <Modal.Body>
            {
              props.showModalOrderRef &&
              <RefundableCheck orderId={props.orderId} t={props.t} />
            }
          </Modal.Body>
          <Modal.Footer>
            <Button variant='primary' onClick={() => props.setShowModalOrderRef( false)}>
              {props.t('CLOSE')}
            </Button>
          </Modal.Footer>
        </Modal>
  );
};

export default RefundOrderModal;